// Import utilities and components for Date Time
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { disableWeekends, workingDays } from "../../functions";
import { useAuthInfo } from "../../hooks";
import _ from "lodash";

export function CustomMUIDatePickerWithErrors({
  name,
  errors,
  shouldHaveMinDate,
  shouldDisableWeekends,
}) {
  // Access the decoded authentication information
  const decoded = useAuthInfo();
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        slotProps={{
          textField: {
            fullWidth: true,
            required: true,
            error: errors && errors.needByDate && true,
            helperText:
              errors && errors.needByDate !== "" ? errors.needByDate : "",
            id: `${name}`,
            name: `${name}`,
            readOnly: true,
          },
        }}
        label={_.startCase(name)}
        id={name}
        name={name}
        minDate={shouldHaveMinDate && moment(workingDays(decoded))}
        shouldDisableDate={shouldDisableWeekends && disableWeekends}
      />
    </LocalizationProvider>
  );
}
